import React, { useContext } from "react";
import { Segment, Button, Icon } from "semantic-ui-react";
import BreadcrumbContainer from "../../../../app/common/breadcrumb/BreadcrumbContainer";
import ListCertificates from "./ListCertificates";
import { RootStoreContext } from "../../../../app/stores/rootStore";
import CreateCertificateForm from "./CreateCertificateForm";

interface IProps {
  sections: any[];
}

const DashboardCertificate: React.FC<IProps> = ({ sections }) => {
  const rootStore = useContext(RootStoreContext);
  const { openModal } = rootStore.modalStore;
  document.title = "Certificado digital";
  return (
    <div className="configurationContent">
      <BreadcrumbContainer title="Certificado digital" sections={sections} />
      <Segment padded="very">
        <Button
          onClick={() => openModal(<CreateCertificateForm />, "Crear certificado")}
          color="blue"
        >
          <Icon name="add" /> Agregar certificado
        </Button>
        <br /><br/>
        <ListCertificates />
      </Segment>
    </div>
  );
};

export default DashboardCertificate;
